<template>
  <div class="w-100 h-100" style="background-color: #f5f4f7; padding: 15px">
    <a-card style="height: auto">
      <h3>
        {{ $t('linkage.basicInfo') }}
        <a-space style="float: right">
          <a-button :loading="isSaving" type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
          <a-button @click="goBack">{{ $t('buttons.goBack') }}</a-button>
        </a-space>
      </h3>
      <a-form-model ref="form" :model="form" :rules="rules" layout="inline">
        <a-form-model-item :label="$t('linkage.groupName')" prop="groupName">
          <a-input v-model="form.groupName" />
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.enabled')">
          <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')"
            v-model="form.enabled" />
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.masterCondition')">
          <a-switch :checked-children="$t('linkage.and')" :un-checked-children="$t('linkage.or')"
            v-model="form.masterCondition" />
        </a-form-model-item>
        <a-form-model-item :label="$t('warningForm.warningRepeat')" prop="warningRepeat">
          <a-select v-model="form.period" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            mode="tags" style="width: 478px; color: #fff">
            <a-select-option value="1">{{ $t('warningForm.Sunday') }}</a-select-option>
            <a-select-option value="2">{{ $t('warningForm.Monday') }}</a-select-option>
            <a-select-option value="3">{{ $t('warningForm.Tuesday') }}</a-select-option>
            <a-select-option value="4">{{ $t('warningForm.Wednesday') }}</a-select-option>
            <a-select-option value="5">{{ $t('warningForm.Thursday') }}</a-select-option>
            <a-select-option value="6">{{ $t('warningForm.Friday') }}</a-select-option>
            <a-select-option value="7">{{ $t('warningForm.Saturday') }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div class="ant-col ant-form-item-label" style="margin: 10px 0;"><label class="">{{ $t('warningForm.effectiveTime') }}</label></div>
      <a-button type="primary" @click="addTimeRange">{{ $t('buttons.add') }}</a-button>
      <ul class="timeRange">
        <li v-for="(t, i) in timeRanges" :key="t.id">
          <el-time-select
            v-model="t.startTime"
            style="width: 100px;"
            size="small"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: t.endTime || '23:55'
            }"
          >
          </el-time-select>
          ~
          <el-time-select
            v-model="t.endTime"
            style="width: 100px;"
            size="small"
            :picker-options="{
              start: t.startTime || '0:00',
              step: '00:05',
              end: '23:55'
            }">
          </el-time-select>
          <a-icon type="close-circle" style="margin-left: 10px; cursor: pointer;" @click="removeTimeRange(i)" />
        </li>
      </ul>
    </a-card>
    <a-card style="margin: 10px 0; height: 240px">
      <h3>
        {{ $t('linkage.masterDevice') }}
        <a-button type="primary" style="float: right" @click="showTempalteModal('master')">{{ $t('warningForm.template')
          }}</a-button>
        <a-button type="primary" style="float: right; margin-right: 10px;" @click="showDeviceModal('master')">{{
          $t('maintain.set') }}</a-button>
      </h3>
      <el-table height="175" :data="masterDeviceList">
        <el-table-column prop="deviceCode" :label="$t('device.code')">
          <template slot-scope="scope">{{ scope.row.deviceCode }}</template>
        </el-table-column>
        <el-table-column prop="deviceName" :label="$t('common.deviceName')">
          <template slot-scope="scope">{{ scope.row.deviceName }}</template>
        </el-table-column>
        <el-table-column prop="deviceType" :label="$t('common.deviceType')">
          <template slot-scope="scope">{{ deviceTypeMap[scope.row.deviceType] }}</template>
        </el-table-column>
        <el-table-column prop="company" :label="$t('common.customer')" width="200">
          <template slot-scope="scope">{{ scope.row.company }}</template>
        </el-table-column>
        <el-table-column prop="dtuCode" :label="$t('common.dtuCode')">
          <template slot-scope="scope">{{ scope.row.dtuCode }}</template>
        </el-table-column>
        <el-table-column prop="model" :label="$t('common.model')">
          <template slot-scope="scope">{{ scope.row.model }}</template>
        </el-table-column>
        <el-table-column prop="driverType" :label="$t('common.driverType')">
          <template slot-scope="scope">{{ scope.row.driverType }}</template>
        </el-table-column>
        <el-table-column width="130" prop="operationCode" :label="$t('linkage.operationCode')">
          <template slot-scope="scope">
            <a-select style="width: 110px" v-if="scope.row.edit" v-model="scope.row.operationCode_temp"
              :key="scope.row.deviceId">
              <a-select-option v-for="(l, k) in linkageControlOperationCodes" :key="k"
                @click.native="selectOperationCode(scope.row, k, 'master')">{{ l }}</a-select-option>
            </a-select>
            <span v-else>{{ linkageControlOperationCodes[scope.row.operationCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusCondition" :label="$t('linkage.statusCondition')" width="150">
          <template slot-scope="scope">
            <a-input v-if="scope.row.edit" v-model="scope.row.statusCondition_temp"
              @focus="handleMiddlewareStrInputFocus(scope.row, 'master', 'statusCondition')" />
            <span v-else>{{ scope.row.statusCondition }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="command" label="指令">
          <template slot-scope="scope">
            <a-input
              v-if="scope.row.edit"
              v-model="scope.row.command_temp"
              @focus="handleMiddlewareStrInputFocus(scope.row, 'master', 'command')"
            />
            <span v-else>{{ scope.row.command }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <a-button v-if="!scope.row.edit" type="link" style="padding-left: 0"
              @click="onEditDevice(scope.row, 'master')">{{ $t('buttons.edit') }}</a-button>
            <a-button v-if="!scope.row.edit" type="link" style="padding-left: 0"
              @click="onDeleteMasterDevice(scope.$index)">{{ $t('buttons.delete') }}</a-button>
            <template v-else>
              <a-button type="link" style="padding-left: 0" @click="onSaveDevice(scope.row, 'master')">{{
                $t('buttons.save') }}</a-button>
              <a-button type="link" style="padding-left: 0" @click="onCancelDevice(scope.row, 'master')">{{
                $t('common.cancelText') }}</a-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </a-card>
    <a-card style="height: 440px">
      <h3>
        {{ $t('linkage.slaveDevice') }}
        <a-button type="primary" style="float: right" @click="showTempalteModal('slave')">{{ $t('warningForm.template')
          }}</a-button>
        <a-button type="primary" style="float: right; margin-right: 10px;" @click="showDeviceModal('slave')">{{
          $t('maintain.set') }}</a-button>
      </h3>
      <el-table height="375" :data="slaveDeviceList">
        <el-table-column prop="deviceCode" :label="$t('device.code')" />
        <el-table-column prop="deviceName" :label="$t('common.deviceName')" />
        <el-table-column prop="deviceType" :label="$t('common.deviceType')"><template slot-scope="scope">{{
          deviceTypeMap[scope.row.deviceType] }}</template>
        </el-table-column>
        <el-table-column prop="company" :label="$t('common.customer')" width="200" />
        <el-table-column prop="dtuCode" :label="$t('common.dtuCode')" />
        <el-table-column prop="model" :label="$t('common.model')" />
        <el-table-column prop="driverType" :label="$t('common.driverType')" />
        <el-table-column width="130" prop="operationCode" :label="$t('linkage.operationCode')">
          <template slot-scope="scope">
            <div v-if="scope.row.edit" class="ant-form-item-control"
              :class="{ 'has-error': errorOptions[scope.$index].operationCode }">
              <a-select style="width: 110px" v-model="scope.row.operationCode_temp" :key="scope.row.id"
                @blur="validate('operationCode', scope.row, scope.$index)">
                <a-select-option v-for="(l, k) in linkageControlOperationCodes" :key="k"
                  @click.native="selectOperationCode(scope.row, k, 'slave')">{{ l }}</a-select-option>
              </a-select>
              <div class="ant-form-explain" v-show="errorOptions[scope.$index].operationCode">{{ $t('linkage.soc') }}
              </div>
            </div>
            <span v-else>{{ linkageControlOperationCodes[scope.row.operationCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusCondition" :label="$t('linkage.statusCondition')" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.edit" class="ant-form-item-control"
              :class="{ 'has-error': errorOptions[scope.$index].statusCondition }">
              <a-input v-if="scope.row.edit" v-model="scope.row.statusCondition_temp"
                @focus="handleMiddlewareStrInputFocus(scope.row, 'slave', 'statusCondition', scope.$index)" />
              <div class="ant-form-explain" v-show="errorOptions[scope.$index].statusCondition">{{ $t('linkage.ssc') }}
              </div>
            </div>
            <span v-else>{{ scope.row.statusCondition }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="command" :label="$t('linkage.command')">
          <template slot-scope="scope">
            <div v-if="scope.row.edit" class="ant-form-item-control"
              :class="{ 'has-error': errorOptions[scope.$index].command }">
              <a-input v-if="scope.row.edit" v-model="scope.row.command_temp"
                @focus="handleCommandStrInputFocus(scope.row, 'slave', 'command', scope.$index)" />
              <div class="ant-form-explain" v-show="errorOptions[scope.$index].command">{{ $t('linkage.sc') }}</div>
            </div>
            <span v-else>{{ scope.row.command }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <template v-if="!scope.row.edit">
              <a-button type="link" style="padding-left: 0" @click="onEditDevice(scope.row, 'slave')">{{
                $t('buttons.edit') }}</a-button>
              <a-button type="link" style="padding-left: 0" @click="onDeleteSlaveDevice(scope.$index)">{{
                $t('buttons.delete') }}</a-button>
            </template>
            <template v-else>
              <a-button type="link" style="padding-left: 0" @click="onSaveDevice(scope.row, 'slave', scope.$index)">{{
                $t('buttons.save') }}</a-button>
              <a-button type="link" style="padding-left: 0" @click="onCancelDevice(scope.row, 'slave')">{{
                $t('common.cancelText') }}</a-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </a-card>
    <a-modal width="70%" v-model="innerDeviceVisible" :title="$t('device.deviceSelect')"
      @cancel="handleCloseInnerDeviceModal" @ok="handleConfirmInnerDeviceSelction">
      <a-table row-key="id" :class="nowType" :loading="innerDeviceLoading" :columns="columns" :pagination="pagination"
        :data-source="innerDeviceList" :rowSelection="rowSelection" @change="handlePageChange">
        <template v-for="c in columns" v-slot:[c.key]="text">
          <text-highlight :key="c.key" :queries="[innerDeviceHighlightInfo[c.key]]">{{ c.key === 'type' ?
            deviceTypeMap[text] : text }}</text-highlight>
        </template>
      </a-table>
    </a-modal>
    <div data-v-4f61c048 class="ant-modal-root" v-show="middlewareModalVisible">
      <div class="ant-modal-mask"></div>
      <div tabindex="-1" role="dialog" aria-labelledby="rcDialogTitle0" class="ant-modal-wrap">
        <div role="document" class="ant-modal" style="width: 1000px; transform-origin: 728px 282px;">
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div @click.stop class="ant-modal-content">
            <button @click="closeMiddlewareModal" type="button" aria-label="Close" class="ant-modal-close">
              <span class="ant-modal-close-x">
                <i aria-label="图标: close" class="anticon anticon-close ant-modal-close-icon">
                  <svg viewBox="64 64 896 896" data-icon="close" width="1em" height="1em" fill="currentColor"
                    aria-hidden="true" focusable="false" class>
                    <path
                      d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
                  </svg>
                </i>
              </span>
            </button>
            <div class="ant-modal-header">
              <div id="rcDialogTitle0" class="ant-modal-title">{{ title }}</div>
            </div>
            <div class="ant-modal-body">
              <a-input style="margin-bottom: 15px" :placeholder="$t('linkage.searchPoints')"
                v-model="searchParamsOfCode" @keyup.enter="searchPoint" />
              <a-table :columns="protocolColumns" :data-source="points" :loading="protocolTableLoading"
                :customRow="handleRowClick" row-key="code"></a-table>
              <a-input v-model="middlewareStr" />
            </div>
            <div class="ant-modal-footer">
              <div>
                <button @click="closeMiddlewareModal" type="button" class="ant-btn">
                  <span>{{ $t('common.cancelText') }}</span>
                </button>
                <button @click="confirmMiddlewareStr" type="button" class="ant-btn ant-btn-primary">
                  <span>{{ $t('common.okText') }}</span>
                </button>
              </div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <div class="ant-modal-root" v-show="commandModalVisible">
      <div class="ant-modal-mask"></div>
      <div tabindex="-1" role="dialog" aria-labelledby="rcDialogTitle0" class="ant-modal-wrap">
        <div role="document" class="ant-modal" style="width: 1000px; transform-origin: 728px 282px;">
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div @click.stop class="ant-modal-content">
            <button @click="closeCommandModal" type="button" aria-label="Close" class="ant-modal-close">
              <span class="ant-modal-close-x">
                <i aria-label="图标: close" class="anticon anticon-close ant-modal-close-icon">
                  <svg viewBox="64 64 896 896" data-icon="close" width="1em" height="1em" fill="currentColor"
                    aria-hidden="true" focusable="false" class>
                    <path
                      d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
                  </svg>
                </i>
              </span>
            </button>
            <div class="ant-modal-header">
              <div id="rcDialogTitle0" class="ant-modal-title">{{ $t('linkage.cs') }}</div>
            </div>
            <div class="ant-modal-body">
              <a-input style="margin-bottom: 15px" :placeholder="$t('linkage.searchPoints')"
                v-model="searchParamsOfCode" @keyup.enter="searchPoint" />
              <a-table :columns="protocolColumns" :data-source="points" :loading="protocolTableLoading"
                :rowSelection="commandSelection" :locale="{ emptyText: $t('linkage.empty') }" row-key="code">
                <template v-slot:operation="_, record">
                  <a-button type="link" style="padding: 0" @click="toggleState(record)">{{ record.edit ?
                    $t('buttons.save') : $t('buttons.edit') }}</a-button>
                  <a-button type="link" style="padding: 0; padding-left: 10px" v-show="record.edit"
                    @click="cancelEdit(record)">{{ $t('common.cancelText') }}</a-button>
                </template>
                <template v-slot:value="_, record">
                  <div v-if="record.edit">
                    <!-- <a-select :value="record.value_temp" style="width: 90%;" v-if="record.valueRules && record.valueRules.length" show-search>
                      <a-select-option v-for="v in record.valueRules" :key="v.targetValue" @click.native="selectValue(v.match, v.targetValue, record)">
                        {{ symbols[v.match] + v.targetValue }} {{ v.value }}
                      </a-select-option>
                    </a-select> -->
                    <a-dropdown :trigger="['click']" style="width: 90%;"
                      v-if="record.valueRules && record.valueRules.length">
                      <a-input :value="record.value_temp" @change="handleInputValueChange($event, record)" />
                      <a-menu slot="overlay">
                        <a-menu-item v-for="v in record.valueRules" :key="v.targetValue"
                          @click.native="selectValue(v.match, v.targetValue, record)">
                          {{ symbols[v.match] + v.targetValue }} {{ v.value }}
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                    <a-input v-else :value="record.value_temp" style="width: 90%;"
                      @change="handleInputValueChange($event, record)" />
                  </div>
                  <div v-else>{{ record.value }}</div>
                </template>
              </a-table>
              <div style="overflow: hidden;" :style="{ marginTop: points.length ? '0px' : '30px' }">
                <a-button style="float: left;" type="primary" @click="setCommandStr">{{ $t('linkage.create')
                  }}</a-button><a-input v-model="middlewareStr" style="float: right; width: 90%" />
              </div>
              <div style="height: 30px; position: relative">
                <div class="ant-form-extra"
                  style="position: absolute; right: 90%; top: 10%; white-space: nowrap; transform: translateX(100%)">{{
                    $t('linkage.extra') }}</div>
              </div>
            </div>
            <div class="ant-modal-footer">
              <div>
                <button @click="closeCommandModal" type="button" class="ant-btn">
                  <span>{{ $t('common.cancelText') }}</span>
                </button>
                <button @click="confirmCommandStr" type="button" class="ant-btn ant-btn-primary">
                  <span>{{ $t('common.okText') }}</span>
                </button>
              </div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <a-modal :title="templateModalTitle" v-model="isTemplateModalShow" :width="1000">
      <template slot="footer">
        <div></div>
        <!-- <a-button>{{ $t('common.cancelText') }}</a-button>
        <a-button type="primary">{{ $t('visitRecords.import') }}</a-button> -->
      </template>
      <a-button type="primary" style="margin-left: 10px;" @click="showTemplateForm()">{{ $t('buttons.add') }}</a-button>
      <div class="templateContainer">
        <div class="box" v-for="(t, i) in templates" :key="t.id" :style="`height: ${height}`">
          <div style="position: absolute; right: 5%; top: 6%;">
            <a-button type="link" @click="showTemplateForm(t)">{{ $t('buttons.edit') }}</a-button>
            <a-popconfirm :title="$t('messages.ctrd')" :ok-text="$t('common.yes')" :cancel-text="$t('common.no')"
              @confirm="deleteTemplate(t, i)">
              <a-button type="link" style="color: #ff4d4f; padding-left: 0;" :loading="t.isTemplateDeleting">{{
                $t('buttons.delete') }}</a-button>
            </a-popconfirm>
            <a-dropdown :trigger="['click']" v-show="deviceMenus.length > 1">
              <a-button type="link" style="padding-left: 0;">{{ $t('visitRecords.import') }}</a-button>
              <a-menu slot="overlay">
                <a-menu-item v-for="d in deviceMenus" :key="d.deviceId">
                  <a href="javascript:;" @click="importTemplate(t, d)">{{ d.deviceName }} - {{ d.deviceCode }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-button v-show="deviceMenus.length === 1" type="link" style="padding-left: 0;"
              @click="importTemplate(t, deviceMenus[0])">{{ $t('visitRecords.import') }}</a-button>
          </div>
          <el-card class="content">
            <h3>{{ $t('dataReport.templateName') }}: {{ t.name }}</h3>
            <p>
              {{ $t('linkage.operationCode') }}: {{ linkageControlOperationCodes[t.operation] }}
            </p>
            <p :style="`margin-bottom: ${templateModalTitle === $t('linkage.st') ? '15px' : '0'}`">
              {{ $t('linkage.statusCondition') }}: {{ t.condition }}
            </p>
            <p v-if="templateModalTitle === $t('linkage.st')" style="margin-bottom: 0;">
              {{ $t('linkage.command') }}: {{ t.command }}
            </p>
          </el-card>
        </div>
      </div>
    </a-modal>
    <a-modal :title="$t('warningForm.template')" v-model="isTemplateFormShow" :width="800" @ok="submitTemplate"
      :confirmLoading="isTemplateSubmitting" :afterClose="clearTemplateForm">
      <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item :label="$t('dataReport.templateName')">
          <a-input v-model="templateForm.name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.operationCode')">
          <a-select v-model="templateForm.operation">
            <a-select-option v-for="(l, k) in linkageControlOperationCodes" :key="k">{{ l }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.statusCondition')">
          <a-input v-model="templateForm.condition" />
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.command')" v-if="templateModalTitle === this.$t('linkage.st')">
          <a-input v-model="templateForm.command" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import TextHighlight from "vue-text-highlight"
import { searchDeviceList } from "@/api/device"
import { addLinkage, getDetails, updateLinkage } from "@/api/linkage"
import { getDict } from "@/api/dict"
import { getProtocol } from "@/api/protocol"
import { nanoid } from "nanoid"
import { f, u } from '@/api/order'

export default {
  components: { TextHighlight },
  data() {
    return {
      form: {
        groupCode: "",
        groupName: "",
        enabled: true,
        masterCondition: true,
        period: []
      },
      rules: {
        groupName: [
          {
            required: true,
            message: this.$t('linkage.egn'),
            trigger: "blur"
          }
        ]
      },
      masterDeviceList: [],
      linkageControlOperationCodes: {},
      deviceTypeMap: {},
      deviceStatuss: {},
      slaveDeviceList: [],
      innerDeviceVisible: false,
      statusConditionModalVisible: false,
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.handleRowChange,
        columnTitle: ''
      },
      innerDeviceHighlightInfo: {
        code: "",
        name: "",
        type: "",
        "customer.company": "",
        dtuCode: "",
        model: "",
        driverType: ""
      },
      innerDeviceQueryParams: {
        query: [
          {
            field: "code",
            value: ""
          },
          {
            field: "name",
            value: ""
          },
          {
            field: "type",
            value: ""
          },
          {
            field: "customer.company",
            value: ""
          },
          {
            field: "dtuCode",
            value: ""
          },
          {
            field: "model",
            value: ""
          },
          {
            field: "driverType",
            value: ""
          }
        ],
        sort: [
          {
            field: "updatedAt",
            value: "DESC"
          }
        ],
        filter: [
          {
            field: "enabled",
            value: true
          }
        ]
      },
      columns: [
        {
          title: () => (
            <div>
              {this.$t('device.code')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[0].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "code",
          key: "code",
          scopedSlots: {
            customRender: "code"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.deviceName')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[1].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.deviceType')}
              <br />
              <a-select
                style="width: 110px"
                v-model={this.innerDeviceQueryParams.query[2].value}
                onChange={() => this.handleSearch({ key: "Enter" })}
              >
                <a-select-option value="">{this.$t('common.all')}</a-select-option>
                {Object.keys(this.deviceTypeMap).map(d => (
                  <a-select-option value={d}>
                    {this.deviceTypeMap[d]}
                  </a-select-option>
                ))}
              </a-select>
            </div>
          ),
          dataIndex: "type",
          key: "type",
          scopedSlots: {
            customRender: "type"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.customer')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[3].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "customer.company",
          key: "customer.company",
          width: 240,
          scopedSlots: {
            customRender: "customer.company"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.dtuCode')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[4].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "dtuCode",
          key: "dtuCode",
          scopedSlots: {
            customRender: "dtuCode"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.model')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[5].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "model",
          key: "model",
          scopedSlots: {
            customRender: "model"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.driverType')}
              <a-input
                allow-clear
                v-model={this.innerDeviceQueryParams.query[6].value}
                onKeyup={this.handleSearch}
              />
            </div>
          ),
          dataIndex: "driverType",
          key: "driverType",
          scopedSlots: {
            customRender: "driverType"
          }
        }
      ],
      nowType: '',
      innerDeviceList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      innerDeviceLoading: false,
      middlewareModalVisible: false,
      searchParamsOfCode: '',
      protocolColumns: [
        {
          title: () => this.$t('linkage.code'),
          dataIndex: "code",
          key: "code"
        },
        {
          title: () => this.$t('linkage.name'),
          dataIndex: "name",
          key: "name"
        },
        {
          title: () => this.$t('linkage.unit'),
          dataIndex: "unit",
          key: "unit"
        },
        {
          title: () => this.$t('linkage.coefficient'),
          dataIndex: "coefficient",
          key: "coefficient"
        }
      ],
      points: [],
      protocolTableLoading: false,
      middlewareStr: '',
      title: '',
      errorOptions: [],
      isSaving: false,
      commandModalVisible: false,
      commandSelection: {
        selectedRowKeys: [],
        selectedRows: [],
        onChange: this.handleConmandSelectionChange
      },
      symbols: {
        EQ: '=',
        GE: '≥',
        GT: '>',
        LE: '≤',
        LT: '<',
        NE: '≠'
      },
      isTemplateModalShow: false,
      templateModalTitle: '',
      templates: [],
      height: '155px',
      isTemplateFormShow: false,
      templateForm: {
        name: '',
        operation: '',
        condition: '',
        command: ''
      },
      isTemplateSubmitting: false,
      deviceMenus: [],
      timeRanges: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.deviceMap = {}
    this.memo = []
  },
  mounted() {
    this.render()
  },
  methods: {
    translate() {
      this.rules = {
        groupName: [
          {
            required: true,
            message: this.$t('linkage.egn'),
            trigger: "blur"
          }
        ]
      }
      this.setDeviceTypeMap()
      this.setDeviceStatus()
      this.setLinkageControlOperationCode()
    },
    async save() {
      if (!this.masterDeviceList.length) {
        return this.$message.warn(this.$t('linkage.sm'))
      }
      // if (this.masterDeviceList[0].edit) {
      //   this.onSaveDevice(this.masterDeviceList[0], 'master')
      //   this.masterDeviceList[0].edit = false
      //   this.masterDeviceList = [...this.masterDeviceList]
      // }
      let mDevice
      for (let i = 0; i < this.masterDeviceList.length; i++) {
        mDevice = this.masterDeviceList[i]
        if (mDevice.edit) {
          this.onSaveDevice(mDevice, 'master')
          mDevice.edit = false
        }
      }
      this.masterDeviceList = [...this.masterDeviceList]
      let f = true, result, device
      for (let i = 0; i < this.slaveDeviceList.length; i++) {
        device = this.slaveDeviceList[i]
        if (!device.edit) {
          device.operationCode_temp = device.operationCode
          device.statusCondition_temp = device.statusCondition
          device.command_temp = device.command
        }
        result = this.onSaveDevice(this.slaveDeviceList[i], 'slave', i)
        f = f && result
      }
      this.slaveDeviceList = [...this.slaveDeviceList]
      this.$refs.form.validate(valid => f = f && valid)
      if (f) {
        const form = { ...this.form }
        form.masterCondition = form.masterCondition ? 'and' : 'or'
        form.masterDevices = this.masterDeviceList.map(s => ({
          deviceId: s.deviceId,
          operationCode: s.operationCode,
          statusCondition: s.statusCondition
        }))
        form.slaveDevices = this.slaveDeviceList.map(s => ({
          deviceId: s.deviceId,
          operationCode: s.operationCode,
          statusCondition: s.statusCondition,
          command: s.command
        }))
        form.period = form.period + ""
        form.effectiveTime = ""
        if (this.timeRanges?.length) {
          const e = this.timeRanges.map(t => t.startTime + "-" + t.endTime)
          form.effectiveTime = e.join(";")
        }
        try {
          this.isSaving = true
          if (this.id) {
            form.id = this.id
            const { message } = await updateLinkage(form)
            this.$message.success(message)
          } else {
            const { message } = await addLinkage(form)
            this.$message.success(message)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.isSaving = false
          this.goBack()
        }
      }
    },
    goBack() {
      this.$store.commit("setLinkageFlag", true)
      this.$router.back()
    },
    showDeviceModal(type) {
      this.nowType = type
      this.innerDeviceVisible = true
      // if (!this.innerDeviceList.length) {
      //   this.getDeviceList()
      // }
      if (type === 'master') {
        this.rowSelection.selectedRowKeys = this.masterDeviceList.map(s => s.deviceId)
      }
      if (type === 'slave') {
        this.rowSelection.selectedRowKeys = this.slaveDeviceList.map(s => s.deviceId)
      }
    },
    async render() {
      await this.setDeviceTypeMap()
      await this.setLinkageControlOperationCode()
      await this.setDeviceStatus()
      this.getMemo()
      if (this.$route.query.id) {
        this.getLinkageDetails(this.$route.query.id)
      }
    },
    async setDeviceTypeMap() {
      const dtm = {}
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const { data } = await getDict(lang, "deviceType")
        data.content.forEach(c => {
          dtm[c.value] = c.text
        })
        this.deviceTypeMap = dtm
      } catch (e) {
        console.log(e)
      }
    },
    async setLinkageControlOperationCode() {
      const dtm = {}
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const { data } = await getDict(lang, "linkageControlOperationCode")
        data.content.forEach(c => {
          dtm[c.value] = c.text
        })
        this.linkageControlOperationCodes = dtm
      } catch (e) {
        console.log(e)
      }
    },
    async setDeviceStatus() {
      const ds = {}
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const { data } = await getDict(lang, "deviceStatus")
        data.content.forEach(c => {
          ds[c.value] = c.text
        })
        this.deviceStatuss = ds
      } catch (e) {
        console.log(e)
      }
    },
    selectOperationCode(r, v, t) {
      this.nowType = t
      if (t === 'master') {
        this.masterDeviceList = [...this.masterDeviceList]
      }
      if (t === 'slave') {
        this.slaveDeviceList = [...this.slaveDeviceList]
      }
    },
    handleRowChange(keys, rows) {
      rows.map(s => this.deviceMap[s.id] = s)
      this.rowSelection.selectedRowKeys = keys
    },
    async getDeviceList() {
      this.innerDeviceLoading = true
      try {
        const { data } = await searchDeviceList(
          this.pagination.current,
          this.pagination.pageSize,
          this.innerDeviceQueryParams
        )
        this.innerDeviceList = data.records
        this.innerDeviceQueryParams.query.forEach(q => {
          this.innerDeviceHighlightInfo[q.field] = q.value
        })
        this.pagination.current = data.current
        this.pagination.total = data.total
      } catch (e) {
        console.log(e)
      } finally {
        this.innerDeviceLoading = false
      }
    },
    handleSearch(e) {
      if (e.key === "Enter") {
        this.pagination.current = 1
        this.getDeviceList()
      }
    },
    handlePageChange(pagination) {
      this.pagination = pagination
      this.getDeviceList()
    },
    handleCloseInnerDeviceModal() {
      this.innerDeviceVisible = false
      this.rowSelection.selectedRowKeys = []
    },
    handleConfirmInnerDeviceSelction() {
      let device
      if (this.nowType === 'master') {
        let index
        this.masterDeviceList = this.rowSelection.selectedRowKeys.map(deviceId => {
          index = this.masterDeviceList.findIndex(s => s.deviceId == deviceId)
          if (index >= 0) {
            return this.masterDeviceList[index]
          }
          device = this.deviceMap[deviceId]
          device = {
            brand: device.brand,
            company: device.customer.company,
            deviceCode: device.code,
            deviceId: device.id,
            deviceName: device.name,
            deviceType: device.type,
            driverType: device.driverType,
            dtuCode: device.dtuCode,
            model: device.model,
            operationCode: '',
            operationCode_temp: '',
            protocolCode: device.protocolCode,
            remark: null,
            statusCondition: '',
            statusCondition_temp: '',
            command: '',
            command_temp: '',
            edit: true
          }
          return device
        })
      }
      if (this.nowType === 'slave') {
        const errorOptions = []
        let index
        this.slaveDeviceList = this.rowSelection.selectedRowKeys.map(deviceId => {
          index = this.slaveDeviceList.findIndex(s => s.deviceId == deviceId)
          if (index >= 0) {
            errorOptions.push(this.errorOptions[index])
            return this.slaveDeviceList[index]
          }
          device = this.deviceMap[deviceId]
          device = {
            brand: device.brand,
            company: device.customer.company,
            deviceCode: device.code,
            deviceId: device.id,
            deviceName: device.name,
            deviceType: device.type,
            driverType: device.driverType,
            dtuCode: device.dtuCode,
            model: device.model,
            operationCode: '',
            operationCode_temp: '',
            protocolCode: device.protocolCode,
            remark: null,
            statusCondition: '',
            statusCondition_temp: '',
            command: '',
            command_temp: '',
            edit: true
          }
          errorOptions.push({})
          return device
        })
        this.errorOptions = errorOptions
      }
      this.handleCloseInnerDeviceModal()
    },
    async handleMiddlewareStrInputFocus(row, type, field, i) {
      this.nowType = type
      this.middlewareModalVisible = true
      this.title = this.$t('linkage.ssct')
      this.protocolColumns = [
        {
          title: () => this.$t('linkage.code'),
          dataIndex: "code",
          key: "code"
        },
        {
          title: () => this.$t('linkage.name'),
          dataIndex: "name",
          key: "name"
        },
        {
          title: () => this.$t('linkage.unit'),
          dataIndex: "unit",
          key: "unit"
        },
        {
          title: () => this.$t('linkage.coefficient'),
          dataIndex: "coefficient",
          key: "coefficient"
        }
      ]
      this.protocolTableLoading = true
      this.middlewareStr = row[`${field}_temp`] || ''
      this.field = field
      this.row = row
      this.index = i
      try {
        const { data } = await getProtocol(row.protocolCode)
        this.points = this.originPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
          (p.details || []).forEach(d => {
            p[d.locale] = d.name
          })
          if (!p['zh-CN']) {
            p['zh-CN'] = p.name
          }
          if (!p['en-US']) {
            p['en-US'] = p['zh-CN']
          }
          return p
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.protocolTableLoading = false
      }
    },
    async handleCommandStrInputFocus(row, type, field, i) {
      this.nowType = type
      this.protocolColumns = [
        {
          title: () => this.$t('linkage.code'),
          dataIndex: "code",
          key: "code"
        },
        {
          title: () => this.$t('linkage.name'),
          dataIndex: "name",
          key: "name"
        },
        {
          title: () => this.$t('linkage.unit'),
          dataIndex: "unit",
          key: "unit"
        },
        {
          title: () => this.$t('linkage.coefficient'),
          dataIndex: "coefficient",
          key: "coefficient"
        },
        {
          title: () => this.$t('device.value'),
          dataIndex: 'value',
          key: 'value',
          scopedSlots: {
            customRender: 'value'
          },
          width: 190
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: {
            customRender: 'operation'
          }
        }
      ]
      this.commandModalVisible = true
      this.protocolTableLoading = true
      this.middlewareStr = row[`${field}_temp`] || ''
      this.field = field
      this.row = row
      this.index = i
      let value = this.middlewareStr.split(';'), v
      const valueMap = {}
      for (let i = 0; i < value.length; i++) {
        v = value[i].split('=')
        valueMap[v[0].substring(1)] = v[1]
      }
      try {
        const { data } = await getProtocol(row.protocolCode)

        this.points = this.originPoints = data.points.filter(p => p.dataWrite === 1 || p.dataWrite === 4).map(p => {
          (p.details || []).forEach(d => {
            p[d.locale] = d.name
          })
          if (!p['zh-CN']) {
            p['zh-CN'] = p.name
          }
          if (!p['en-US']) {
            p['en-US'] = p['zh-CN']
          }
          p.value = valueMap[p.code] || ''
          if (valueMap[p.code]) {
            this.commandSelection.selectedRowKeys.push(p.code)
            this.commandSelection.selectedRows.push(p)
          }
          return p
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.protocolTableLoading = false
      }
    },
    closeMiddlewareModal() {
      this.middlewareModalVisible = false
      this.middlewareStr = ''
      this.originPoints = this.points = []
      this.searchParamsOfCode = ''
      this.title = ''
      this.row = null
      this.index = null
    },
    closeCommandModal() {
      this.commandModalVisible = false
      this.middlewareStr = ''
      this.originPoints = this.points = []
      this.searchParamsOfCode = ''
      this.row = null
      this.index = null
      this.commandSelection.selectedRowKeys = []
      this.commandSelection.selectedKeys = []
    },
    searchPoint(e) {
      if (e.key === "Enter") {
        this.protocolTableLoading = true;
        const points = [];
        for (let i = 0; i < this.originPoints.length; i++) {
          const point = this.originPoints[i];
          if (
            point.code.includes(this.searchParamsOfCode) ||
            point["zh-CN"].includes(this.searchParamsOfCode) ||
            point["en-US"].includes(this.searchParamsOfCode) ||
            point.unit.includes(this.searchParamsOfCode) ||
            point.coefficient.includes(this.searchParamsOfCode)
          ) {
            points.push(point)
          }
        }
        this.points = points
        this.protocolTableLoading = false
      }
    },
    handleRowClick(r) {
      return {
        on: {
          click: () => {
            this.middlewareStr += '#' + r.code
          }
        }
      }
    },
    confirmMiddlewareStr() {
      this.row[`${this.field}_temp`] = this.middlewareStr
      if (this.nowType === 'master') {
        this.masterDeviceList = [...this.masterDeviceList]
      }
      if (this.nowType === 'slave') {
        this.slaveDeviceList = [...this.slaveDeviceList]
        this.validate(this.field, this.row, this.index)
      }
      this.closeMiddlewareModal()
    },
    confirmCommandStr() {
      this.row[`${this.field}_temp`] = this.middlewareStr
      if (this.nowType === 'master') {
        this.masterDeviceList = [...this.masterDeviceList]
      }
      if (this.nowType === 'slave') {
        this.slaveDeviceList = [...this.slaveDeviceList]
        this.validate(this.field, this.row, this.index)
      }
      this.closeCommandModal()
    },
    onEditDevice(r, type) {
      this.nowType = type
      r.edit = true
      r.operationCode_temp = r.operationCode
      r.statusCondition_temp = r.statusCondition
      r.command_temp = r.command
      this[`${type}DeviceList`] = [...this[`${type}DeviceList`]]
    },
    onSaveDevice(r, type, i) {
      if (i !== undefined && i !== null) {
        let f0 = this.validate('operationCode', r, i)
        let f1 = this.validate('statusCondition', r, i)
        let f2 = this.validate('command', r, i)
        if (!(f0 && f1 && f2)) {
          this.nowType = type
          return false
        }
      }
      r.operationCode = r.operationCode_temp
      r.statusCondition = r.statusCondition_temp
      r.command = r.command_temp
      this.onCancelDevice(r, type)
      return true
    },
    onCancelDevice(r, type) {
      this.nowType = type
      r.edit = false
      r.operationCode_temp = ''
      r.statusCondition_temp = ''
      r.command_temp = ''
      this[`${type}DeviceList`] = [...this[`${type}DeviceList`]]
    },
    onDeleteMasterDevice(i) {
      this.masterDeviceList.splice(i, 1)
      this.masterDeviceList = [...this.masterDeviceList]
    },
    onDeleteSlaveDevice(i) {
      this.slaveDeviceList.splice(i, 1)
      this.errorOptions.splice(i, 1)
      this.slaveDeviceList = [...this.slaveDeviceList]
    },
    validate(c, r, i) {
      let f
      const errorOptions = [...this.errorOptions]
      if (
        typeof r[`${c}_temp`] === "number" ||
        (typeof r[`${c}_temp`] === "string" && r[`${c}_temp`]) ||
        (c === 'command' && r.operationCode_temp !== 'COMMAND' && r.operationCode_temp !== '')
      ) {
        errorOptions[i][c] = false
        f = true
      } else {
        this.slaveDeviceList[i].edit = true
        errorOptions[i][c] = true
        f = false
      }
      this.errorOptions = errorOptions
      return f
    },
    async getLinkageDetails(id) {
      this.id = id
      try {
        const { data } = await getDetails(id)
        this.form.enabled = data.enabled
        this.form.groupCode = data.groupCode
        this.form.groupName = data.groupName
        this.form.masterCondition = data.masterCondition === 'or' ? false : true
        this.form.period = data.period ? data.period.split(",") : []
        this.masterDeviceList = data.masterDevices
        this.slaveDeviceList = data.slaveDevices
        const trs = []
        if (data.effectiveTime) {
          this.timeRanges = (data.effectiveTime || "").split(";").map(t => {
            const [startTime, endTime] = t.split("-")
            trs.push({
              id: nanoid(),
              startTime,
              endTime
            })
          })
        }
        this.timeRanges = trs
        this.errorOptions = this.slaveDeviceList.map(() => {
          return {}
        })
      } catch (e) {
        console.log(e)
      }
    },
    handleConmandSelectionChange(keys, rows) {
      this.commandSelection.selectedRowKeys = keys
      this.commandSelection.selectedRows = rows
    },
    toggleState(r) {
      r.edit = !r.edit
      if (!r.edit) {
        r.value = r.value_temp
      } else {
        r.value_temp = r.value
      }
      this.points = [...this.points]
    },
    selectValue(m, v, r) {
      r.value_temp = v
      r.match = m
      this.points = [...this.points]
    },
    cancelEdit(r) {
      r.edit = false
      r.value_temp = ''
      this.points = [...this.points]
    },
    handleInputValueChange(e, r) {
      r.value_temp = e.target.value
      this.$forceUpdate()
    },
    setCommandStr() {
      let r, code, value, result = ''
      for (let i = 0; i < this.commandSelection.selectedRows.length; i++) {
        r = this.commandSelection.selectedRows[i]
        value = r.edit ? r.value_temp : r.value
        code = '#' + r.code
        result += code + '=' + value + ';'
      }
      this.middlewareStr = result
    },
    showTempalteModal(type) {
      this.isTemplateModalShow = true
      if (type === 'master') {
        this.templateModalTitle = this.$t('linkage.mt')
        this.deviceMenus = this.masterDeviceList
        this.templates = this.memo[3]
        this.height = '155px'
      }
      if (type === 'slave') {
        this.templateModalTitle = this.$t('linkage.st')
        this.deviceMenus = this.slaveDeviceList
        this.templates = this.memo[4]
        this.height = '200px'
      }
    },
    showTemplateForm(t) {
      this.isTemplateFormShow = true
      if (t) {
        this.templateForm = t
      }
    },
    async submitTemplate() {
      this.isTemplateSubmitting = true
      try {
        const template = {
          ...this.templateForm
        }
        if (this.templateModalTitle === this.$t('linkage.mt')) {
          if (template.id) {
            const i = this.templates.findIndex(t => t.id === template.id)
            this.memo[3][i] = template
          } else {
            template.id = nanoid()
            this.memo[3].push(template)
          }
        }
        if (this.templateModalTitle === this.$t('linkage.st')) {
          if (template.id) {
            const i = this.templates.findIndex(t => t.id === template.id)
            this.memo[4][i] = template
          } else {
            template.id = nanoid()
            this.memo[4].push(template)
          }
        }
        const { message } = await u(this.memo)
        this.$message.success(message)
        this.isTemplateFormShow = false
        this.getMemo()
      } catch (e) {
        console.log(e)
      } finally {
        this.isTemplateSubmitting = false
      }
    },
    async deleteTemplate(t, i) {
      t.isTemplateDeleting = true
      this.$forceUpdate()
      try {
        if (this.templateModalTitle === this.$t('linkage.mt')) {
          this.memo[3].splice(i, 1)
        }
        if (this.templateModalTitle === this.$t('linkage.st')) {
          this.memo[4].splice(i, 1)
        }
        const { message } = await u(this.memo)
        this.$message.success(message)
        this.getMemo()
      } catch (e) {
        console.log(e)
      }
    },
    async getMemo() {
      try {
        const { data } = await f()
        this.memo = data
      } catch (e) {
        console.log(e)
      }
    },
    clearTemplateForm() {
      this.templateForm = {
        name: '',
        operation: '',
        condition: '',
        command: ''
      }
    },
    importTemplate(t, d) {
      if (!this.masterDeviceList.length) return this.$message.warn(this.$t('linkage.sm'))
      if (this.templateModalTitle === this.$t('linkage.mt')) {
        if (d.edit) {
          d.operationCode_temp = t.operation
          d.statusCondition_temp = t.condition
        } else {
          d.operationCode = t.operation
          d.statusCondition = t.condition
        }
        this.masterDeviceList = [...this.masterDeviceList]
      }
      if (this.templateModalTitle === this.$t('linkage.st')) {
        if (d.edit) {
          d.operationCode_temp = t.operation
          d.statusCondition_temp = t.condition
          d.command_temp = t.command
        } else {
          d.operationCode = t.operation
          d.statusCondition = t.condition
          d.command = t.command
        }
        this.slaveDeviceList = [...this.slaveDeviceList]
      }
      this.isTemplateModalShow = false
    },
    removeTimeRange(i) {
      this.timeRanges.splice(i, 1)
    },
    addTimeRange() {
      this.timeRanges.push({
        id: nanoid(),
        startTime: null,
        endTime: null
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}

/deep/ .ant-table-row:hover {
  cursor: pointer;
}

.templateContainer {
  width: 100%;
  height: 600px;
  // background-color: skyblue;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  .box {
    padding: 10px;
    min-width: 280px;
    position: relative;

    .content {
      height: 100%;
      word-wrap: break-word;
      overflow: auto;
    }
  }
}
.timeRange {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  li {
    margin-right: 20px;
    margin-bottom: 15px;
  }
}
</style>